// AlertContext.js
import { createContext } from 'react';

/**
 * Contesto per gli alert
 * @type {React.Context<{
 *   addAlert: (props: AlertProps) => [string, () => void],
 *   removeAlert: (id: string) => void,
 *   removeAllAlerts: () => void,
 *   showConfirm: (props: ConfirmProps) => Promise<boolean>
 * }>}
 */
export const AlertContext = createContext(null);